import '../scss/boiler-compare.scss';

const angular = require('angular');
const angularAnimate = require('angular-animate');

(function() {
    "use strict";
    var myApp = angular.module("ketelvergelijker", ['ngAnimate']);



    // Custom filter object to array
    myApp.filter('array', ['$filter', function($filter) {
        return function(items) {

            var filtered = [];

            angular.forEach(items, function(item) {
                filtered.push(item);
            });


            return filtered;
        };
    }]);



    myApp.controller("ketelvergelijker_controller", ['$scope', '$timeout', '$http', '$window', function($scope, $timeout, $http, $window) {

        // Recive all boilers
        $scope.alleKetels = function() {

            $scope.allBoilers = {};
            var filterTypes = ['heating + hot water', 'only hot water', 'heat only', 'hybrid solutions'];



            $http({
                method: 'POST',
                url: '/wp-admin/admin-ajax.php',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {
                    action: 'Boilers', // (zie functions.php in root)
                    filter: filterTypes.toString(),
                    nonce: ajax_var.nonce,
                    function: 'allTypes',
                    uitsluitingen: $scope.uitsluitingen,
                    current_section: $scope.current_section
                }
            }).then(function(data) {
            
                $scope.allBoilers = data.data;
                console.info('data.data', data.data);

                $timeout(function() {
                    $scope.appReady = {
                        opacity: 1,
                        transition: '0.5s'
                    };
                });

            });
        };



        $timeout(function() {
            $scope.alleKetels();
        });

        $scope.selectedBoilers = {};



        $scope.viewType = function(boiler) {
            console.error(boiler);
            $scope.GroupTitle = boiler.title;
            $scope.relatedBoilers = boiler.related;
        };



        // check all selected boilers
        $scope.select = function(event, index, boiler) {
            $timeout(function() {




                if(boiler.active) {

                    delete boiler.active;
                    delete $scope.max;
                    delete $scope.selectedBoilers[boiler.id];
                } else {



                    if($scope.selectedCount >= 3) {
                        $scope.max = "(Maximaal 3 ketels)";
                        return false;
                    }
                    //event.classList.add('active');

                    boiler.active = true;
                    $scope.selectedBoilers[boiler.id] = boiler;
                }

                $scope.selectedCount = Object.keys($scope.selectedBoilers).length; //$window.document.getElementsByClassName('active').length;

                if($scope.selectedCount >= 2) {
                    $scope.compareReady = true;
                }

                //console.log($scope.selectedBoilers);

            });
        };





        $scope.scrollLeft = function() {
            var elmnt = document.getElementById("compare-wrapper");
            scrollTo(elmnt, 0, 400);

        };


        $scope.scrollRight = function() {
            var elmnt = document.getElementById("compare-wrapper");
            scrollTo(elmnt, 750, 400);
        };


        var el = document.getElementById('compare-wrapper');
        swipedetect(el, function(swipedir) {
            var elmnt = document.getElementById("compare-wrapper");
            if(swipedir == 'left') {
                scrollTo(elmnt, 750, 400);
            }

            if(swipedir == 'right') {
                scrollTo(elmnt, 0, 400);
            }
        });



    }]);



    // table row 
    myApp.directive('specRow', function() {
        return {
            template: function(elem, attr) {

                if( attr.key != 'cw_class' ){
                    var html = `
                    <div class="row">
                        <div class="col-xs-3 md-between feature-label">` + attr.title + `</div>
                            <div class="col-xs-3 col-md-3 feature-label end-xs" ng-repeat="b in selectedBoilers | array | orderBy: {data:{id}} ">
                                <span ng-show="{{ b.data.` + attr.key + ` != '' }}">{{ b.data.` + attr.key + ` }} ` + attr.notation + `</span>
                                <span ng-show="{{ b.data.` + attr.key + ` == '' }}">-</span>
                        </div>
                    </div>
                    `;
                }else{
                   var html = `
                   <div class="row">
                       <div class="col-xs-3 md-between feature-label">` + attr.title + `</div>
                            <div ng-if="b.data.` + attr.key + ` <= 6 " class="col-xs-3 col-md-3 feature-label end-xs" ng-repeat="b in selectedBoilers | array | orderBy: {data:{id}} ">
                                <span ng-show="{{ b.data.` + attr.key + ` != '' }}">{{ b.data.` + attr.key + ` }} ` + attr.notation + `</span>
                                <span ng-show="{{ b.data.` + attr.key + ` == '' }}">-</span>
                            </div>
                            <div ng-if="b.data.` + attr.key + ` > 6 " class="col-xs-3 col-md-3 feature-label end-xs" ng-repeat="b in selectedBoilers | array | orderBy: {data:{id}} ">6</div>
                   </div>
                   `;
               }



               return html;
            }
        };

    });

    // table row 
    myApp.directive('imageRow', function() {
        return {
            template: function(elem, attr) {

                var html = `
                <div class="row ">
                

                <div class="col-xs-3 md-around hidden ">
                <div class="hidden-xs back-btn-wrapper">
                <!-- <span class="back-btn-outer btn px-3 py-1" ng-click="compareShow = false;"><i class="back-btn"> &nbsp;</i> Terug</span> -->
                </div>
                </div>
                

                <div class="col-xs-3 col-md-3 center-xs px-2 py-1" ng-repeat="b in selectedBoilers | array | orderBy: {data:{id}} ">
                <img class="w-50" ng-src="{{ b.data.post_thumbnail_url }}" />
                </div>
                </div>
                `;

                return html;
            }
        };

    });


    function swipedetect(el, callback) {

        var touchsurface = el,
        swipedir,
        startX,
        startY,
        dist,
        distX,
        distY,
        threshold = 50,
        restraint = 100,
        allowedTime = 300,
        elapsedTime,
        startTime,
        handleswipe = callback || function(swipedir) {};

        touchsurface.addEventListener('touchstart', function(e) {
            var touchobj = e.changedTouches[0];
            swipedir = 'none';
            dist = 0;
            startX = touchobj.pageX;
            startY = touchobj.pageY;
            startTime = new Date().getTime();
            //e.preventDefault();
        }, false);

        //touchsurface.addEventListener('touchmove', function(e){
        //    e.preventDefault() ;
        //}, false);

        touchsurface.addEventListener('touchend', function(e) {
            var touchobj = e.changedTouches[0];
            distX = touchobj.pageX - startX;
            distY = touchobj.pageY - startY;
            elapsedTime = new Date().getTime() - startTime;
            if(elapsedTime <= allowedTime) {
                if(Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
                    swipedir = (distX < 0) ? 'left' : 'right';
                } else if(Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
                    swipedir = (distY < 0) ? 'up' : 'down';
                }
            }
            handleswipe(swipedir);
            //e.preventDefault();
        }, false);
    }




    function scrollTo(element, to, duration) {
        var start = element.scrollLeft,
        change = to - start,
        currentTime = 0,
        increment = 20;

        var animateScroll = function() {
            currentTime += increment;
            var val = Math.easeInOutQuad(currentTime, start, change, duration);
            element.scrollLeft = val;
            if(currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    }

    //t = current time
    //b = start value
    //c = change in value
    //d = duration
    Math.easeInOutQuad = function(t, b, c, d) {
        t /= d / 2;
        if(t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    };





})();
